<template>
  <div class="search-filter-bar">
    <div class="filter-options-wrapper" v-if="filterOptions">
      <dropdown class="dropdown" forceDown> 
        <div slot="toggle" class="toggle-wrapper">
          <span class="filter-icon">
            <i class="fa-light fa-filter"></i>
          </span>
          <button class="selected-filter-btn">
            <span>
              {{ selectedFilter.name }}
            </span>
            <span class="chevron">
              <i class="fa-light fa-chevron-down"></i>
            </span>
          </button>
        </div>

        <button
          tabindex="0"
          class="dropdown-item"
          v-for="filter in filterOptions"
          :key="filter.id"
          @click.stop.prevent="$emit('on-filter-change', filter)"
          :class="{ active: filter.id == selectedFilter.id }"
        >
          {{ filter.name }}
        </button>
      </dropdown>
      <div class="divider"></div>
    </div>
    <div class="search-input-wrapper">
      <div class="search-icon">
        <i class="fa-light fa-search"></i>
      </div>
      <input
        type="text"
        :value="value"
        :placeholder="placeholder"
        @blur="$emit('blur')"
        @input="$emit('input', $event.target.value)"
        @focus="$emit('focus')"
      />
      <button class="erase-btn" @click="$emit('input', '')" v-show="showEraseBtn">
        <i class="fa-light fa-times"></i>
      </button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    filterOptions: {
      type: Array
    },
    value: {
      type: [Number, String]
    },
    placeholder: {
      type: String
    },
    selectedFilter: {
      type: Object
    }
  },
  computed: {
    showEraseBtn() {
      return this.value != "";
    }
  }
};
</script>

<style lang="less">
.search-filter-bar {
  position: relative;
  width: 100%;
  background: #fff;
  border-radius: 20px;
  display: flex;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
  padding: 6px 16px;
  &:focus-within,
  :active-within {
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.5);
    color: var(--charcoal);
  }

  button {
    outline: none;
    border: none;
    background: transparent;
  }

  .filter-options-wrapper {
    position: relative;
    display: flex;
    flex-direction: row;

    .toggle-wrapper {
      display: flex;
      flex-direction: row;
      align-items: center;
      
    }
    .filter-icon {
      font-size: 12px;
      color: var(--charcoal-50);
    }

    .selected-filter-btn {
      text-align: center;
      // width: clamp(80px, 100%, 200px);
      padding-left: 12px;

      .chevron{
        font-size: 12px;
        margin-left: 8px;
      }
    }

    .divider {
      margin-left: 12px;
      width: 1px;
      height: 100%;
      background-color: var(--charcoal-10);
    }
  }
  .search-input-wrapper {
    position: relative;
    flex-grow: 1;
    display: flex;
    gap: 12px;
    align-items: center;

    .search-icon {
      color: var(--charcoal-50);
      margin-left: 12px;
      font-size: 12px;
    }
    input {
      transition: 0.3s;
      border-radius: 20px;
      width: 100%;
      color: var(--charcoal-75);
      border: none;
      &::placeholder {
        color: var(--charcoal-50);
      }
      &:focus,
      :active {
        outline: none;
        border: none;
      }
    }
  }
}
</style>
